import { render, staticRenderFns } from "./stockLossTask.vue?vue&type=template&id=b45012ca&scoped=true"
import script from "./stockLossTask.vue?vue&type=script&lang=js"
export * from "./stockLossTask.vue?vue&type=script&lang=js"
import style0 from "./stockLossTask.vue?vue&type=style&index=0&id=b45012ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45012ca",
  null
  
)

export default component.exports